import $ from 'jquery';
window.$ = window.jQuery = $;

import './styles/style.scss';

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import VeeValidate, { Validator } from 'vee-validate';
import VueEvents from 'vue-events'
import validationMessages from '~js/vee-validate-pt-BR';
import rotas from './rotas';
import StoragePlugin from './plugins/storage';
import app from './app';
import '~js/validacoes';
import '~diretivas/mascara';
import '~diretivas/tooltip';
import '~diretivas/numero';
import '~diretivas/caracteres-email';
import MensagemImprimirRelatorioPlugin from './plugins/mensagem-imprimir-relatorio';
import MensagemErroPlugin from './plugins/mensagem-erro';
import moment from 'moment';
import toastr from 'toastr';
import '~js/group-by';
import ViaCep from 'vue-viacep'

moment.locale('pt-BR');
window.moment = moment;

toastr.options = {
  "closeButton": true,
  "debug": false,
  "progressBar": true,
  "preventDuplicates": false,
  "positionClass": "toast-top-right",
  "onclick": null,
  "showDuration": "500",
  "hideDuration": "1000",
  "timeOut": "7000",
  "extendedTimeOut": "7000",
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut"
};
window.toastr = toastr;

import 'bootstrap/dist/js/bootstrap';
import 'metismenu/dist/metisMenu';
import 'jquery-slimscroll/jquery.slimscroll';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'animate.css/animate.css';
import 'select2/dist/css/select2.css';
import 'select2-bootstrap-theme/dist/select2-bootstrap.css';
import 'toastr/build/toastr.css';
import 'vue2-dropzone/dist/vue2Dropzone.css';

import FormatarDataFiltro from './filtros/formatar-data';
import FormatarNumeroFiltro from './filtros/formatar-numero';
import FormatarNumeroDataFiltro from './filtros/formatar-numero-data';
import Fixar2digitos from './filtros/fixar2digitos';

Validator.addLocale(validationMessages);

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VeeValidate, {
  locale: 'pt_BR'
});
Vue.use(FormatarDataFiltro);
Vue.use(FormatarNumeroFiltro);
Vue.use(FormatarNumeroDataFiltro);
Vue.use(Fixar2digitos);
Vue.use(StoragePlugin);
Vue.use(VueEvents);
Vue.use(MensagemImprimirRelatorioPlugin);
Vue.use(MensagemErroPlugin);
Vue.use(ViaCep);

/* import * as Sentry from '@sentry/browser'

Sentry.init({
  dsn: 'https://39ba98fb7eaa9d4ade4253b346f5b927@o4507014012469248.ingest.us.sentry.io/4508344149671936',
   integrations: [new Sentry.Integrations.Vue({ Vue })]
});*/

const router = new VueRouter({
  routes: rotas,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

import tipoUsuario from '~js/tipo-usuario';
import { guardarDestino } from '~js/destino-pos-login';
import { analisarDestino } from '~js/acesso-rota';

router.beforeEach((to, from, next) => {
  if (to.name === 'login' && Vue.storage.token()) {
    next('/');
  } else if (to.matched.some(rota => rota.meta.auth) && !Vue.storage.token()) {
    guardarDestino(to);

    next('/login');
  } else if (to.name === 'login') {
    next();
  } else if (to.path === '/') {
    let usuario = router.app.$storage.usuario();

    if (usuario.tipoUsuario === tipoUsuario.UsuarioChat)
      next('/chat');
    else
      next();
  } else {
    next();
  }
});

window.testarDestinoPosLogin = function (caminho) {
  return analisarDestino(router, caminho, Vue.storage.usuario(), Vue.storage.configuracao());
};

app.router = router;

new Vue(app).$mount('#app');



// WEBPACK FOOTER //
// ./FrontEnd/main.js